module.exports = __webpack_public_path__ + "img/straight_line_icon_123.1460f8c9.svg";